import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-900 text-background-200 py-14 md:py-16">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-8 mb-10">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-database-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                Kakobuy <span className="text-primary-400">Finds</span>
              </span>
            </div>
            <p className="text-sm text-foreground-400 max-w-xs leading-relaxed">
              The ultimate spreadsheet database for smart shopping research. Discover better products faster with organized category guides.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 flex-[2]">
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Spreadsheet Guides</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/kakobuy-spreadsheet-guide" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Kakobuy Spreadsheet
                  </Link>
                </li>
                <li>
                  <Link to="/kakobuy-spreadsheet-sneakers" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Sneakers Guide
                  </Link>
                </li>
                <li>
                  <Link to="/kakobuy-spreadsheet-fashion" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Fashion Guide
                  </Link>
                </li>
                <li>
                  <Link to="/kakobuy-spreadsheet-electronics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Electronics Guide
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">More Research</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/kakobuy-spreadsheet-best-finds" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Best Finds
                  </Link>
                </li>
                <li>
                  <Link to="/kakobuy-spreadsheet-beginners" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Beginner Guide
                  </Link>
                </li>
                <li>
                  <Link to="/kakobuy-spreadsheet-accessories" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Accessories Guide
                  </Link>
                </li>
                <li>
                  <Link to="/cssbuy-spreadsheet-guide" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    CSSBuy Spreadsheet
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Quick Links</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Home
                  </Link>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    Kakobuy Sheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    Buy It Now
                  </a>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com/category-911-Shoes.html"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    Browse Categories
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl overflow-hidden flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20art%20print%20in%20warm%20earth%20tones%20of%20terracotta%20olive%20and%20sand%2C%20minimalist%20wall%20art%20photography%2C%20modern%20interior%20detail%2C%20artistic%20composition%2C%20calm%20balanced%20aesthetic&width=200&height=200&seq=footer-thumb-v3&orientation=squarish"
                alt="Kakobuy Spreadsheet organized shopping database"
                title="Smart research with Kakobuy Spreadsheet"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <p className="font-heading text-lg text-foreground-300 italic leading-snug">
                Smart research
                <br />
                Clean finds
                <br />
                Better buys
              </p>
            </div>
          </div>
          <div className="text-center sm:text-right">
            <p className="text-sm text-foreground-500">
              &copy; {new Date().getFullYear()} Kakobuy Finds. All rights reserved.
            </p>
            <div className="flex items-center gap-4 mt-2 justify-center sm:justify-end">
              <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors duration-200 text-sm cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors duration-200 text-sm cursor-pointer" aria-label="Pinterest">
                <i className="ri-pinterest-line"></i>
              </a>
              <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors duration-200 text-sm cursor-pointer" aria-label="Reddit">
                <i className="ri-reddit-line"></i>
              </a>
              <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors duration-200 text-sm cursor-pointer" aria-label="YouTube">
                <i className="ri-youtube-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}